import namespace from './namespace';
import {NAMESPACE as APP_NAMESPACE} from './../app';
import defaultMappingNamespace from './../mappings/namespace'
import {mapUsersByEmailResultEnum} from './enums/mapUsersByEmailResultEnum'

let service = {};
export default {
    async [namespace.actions.GET_DEFAULT_VALUES]({commit, dispatch}) {
        try {
            commit(namespace.mutations.SHOW_LOADER, true);
            commit(namespace.mutations.SET_DEFAULT_VALUES, await service.getDefaultValues());
            commit(namespace.mutations.SHOW_LOADER, false);
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    async [namespace.actions.GET_JIRA_VALUES] ({ commit, dispatch }, { query, filterMappedUsers }) {
        try {
            let dataFromApi = await service.getJiraValues(query, filterMappedUsers);
            commit(namespace.mutations.SET_JIRA_VALUES, dataFromApi);
            return dataFromApi;
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    async [namespace.actions.SET_AVAILABLE_VALUES]({commit, dispatch}, values) {
        try {
            commit(namespace.mutations.SHOW_LOADER, true);
            commit(namespace.mutations.SET_AVAILABLE_VALUES, values);
            commit(namespace.mutations.SHOW_LOADER, false);
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    async [namespace.actions.UPDATE_JIRA_DEFAULT_VALUE]({commit, state, dispatch}, jiraDefaultValue) {
        try {
            commit(namespace.mutations.SHOW_LOADER, true);
            const defaultValuesDto = {
                JiraUserKey: jiraDefaultValue.key,
                JiraUserValue: jiraDefaultValue.label,
                jiraEmail: jiraDefaultValue.email,
                TfsUserKey: state[namespace.state.DEFAULT_VALUES].TfsValue.key,
                TfsUserValue: state[namespace.state.DEFAULT_VALUES].TfsValue.label,
                tfsEmail: state[namespace.state.DEFAULT_VALUES].TfsValue.email,
            }
            await service.updateDefaultValues(defaultValuesDto);

            const defaultValues = {
                JiraValue: jiraDefaultValue,
                TfsValue: state[namespace.state.DEFAULT_VALUES].TfsValue
            }
            commit(namespace.mutations.SET_DEFAULT_VALUES, { DefaultValues: defaultValues });
            commit(namespace.mutations.SHOW_LOADER, false);
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    async [namespace.actions.UPDATE_TFS_DEFAULT_VALUE]({commit, state, dispatch}, tfsDefaultValue) {
        try {
            commit(namespace.mutations.SHOW_LOADER, true);
            const defaultValuesDto = {
                JiraUserKey: state[namespace.state.DEFAULT_VALUES].JiraValue.key,
                JiraUserValue: state[namespace.state.DEFAULT_VALUES].JiraValue.label,
                jiraEmail: state[namespace.state.DEFAULT_VALUES].JiraValue.email,
                TfsUserKey: tfsDefaultValue.key,
                TfsUserValue: tfsDefaultValue.label,
                tfsEmail: tfsDefaultValue.email,
            }
            await service.updateDefaultValues(defaultValuesDto);

            const defaultValues = {
                JiraValue: state[namespace.state.DEFAULT_VALUES].JiraValue,
                TfsValue: tfsDefaultValue
            }
            commit(namespace.mutations.SET_DEFAULT_VALUES, { DefaultValues: defaultValues });
            commit(namespace.mutations.SHOW_LOADER, false);
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        }
    },
    [namespace.actions.SET_UP_SERVICE]({}, payload) {
        if (payload.service !== undefined) {
            service = payload.service;
        }
        if (payload.prefix !== undefined) {
            service.backendUrl = payload.prefix;
        }
    },
    [namespace.actions.HANDLE_ERROR]({commit, dispatch}, error) {
        commit(namespace.mutations.SHOW_LOADER, false);
        dispatch(APP_NAMESPACE.actions.HANDLE_ERROR, error, {root: true});
    },
    async mapByEmail({commit, state, dispatch}, mappings) {
        try {
            commit(`mappings/${defaultMappingNamespace.mutations.SHOW_LOADER}`, true, {root: true});
            const mapUsersByEmailResponse = await service.mapByEmail(state[namespace.state.AVAILABLE_VALUES], mappings);
            let mapUsersByEmailResult = mapUsersByEmailResultEnum.SUCCESS;
            commit(`mappings/SET_MAPPINGS_VALUES`, {
                available: mapUsersByEmailResponse.available,
                mappings: mapUsersByEmailResponse.mappings
            }, {root: true});
            if (mapUsersByEmailResponse.mappedUsersCounter === 0) {
                mapUsersByEmailResult = mapUsersByEmailResultEnum.WARNING;
            }
            commit('setUsersMappingByEmailResult', {
                status: mapUsersByEmailResult,
                mappedUsersCounter: mapUsersByEmailResponse.mappedUsersCounter
            });
            dispatch('fireEmailMappingFlagTimeout');
        } catch (err) {
            dispatch(namespace.actions.HANDLE_ERROR, err);
        } finally {
            commit(`mappings/${defaultMappingNamespace.mutations.SHOW_LOADER}`, false, {root: true});
        }
    },
    async fireEmailMappingFlagTimeout({commit}) {
        return new Promise(resolve => {
            setTimeout(() => {
                commit('hideMappedByEmailFlag')
            }, 4000);
        });
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/usersMapping/actions.js